import { Skeleton } from 'components/common/skeleton';
import PropTypes from 'prop-types';
import './CartAddOn.css';

const SkeletonAddOn = (isMobile = false) => {
    return (
        <div
            className={`ab-cart-add-on-wrapper ${
                isMobile ? 'mobile-add-on-wrapper' : ''
            }`}
        >
            {!isMobile ? (
                <>
                    {' '}
                    <div className="ab-cart-add-on-title">
                        <Skeleton width={250} height={'100%'} minWidth={250} />
                    </div>
                    <div className="ab-cart-add-on-product">
                        <div className="ab-cart-add-on-img">
                            <Skeleton width={100} height={100} minWidth={100} />
                        </div>
                        <div className="ab-cart-add-on-middle-right">
                            <div className="ab-cart-add-on-description">
                                <Skeleton
                                    width={150}
                                    height={10}
                                    minWidth={150}
                                />
                            </div>
                            <div className="">
                                {' '}
                                <Skeleton
                                    width={304}
                                    height={32}
                                    minWidth={304}
                                />
                            </div>
                        </div>
                    </div>
                </>
            ) : (
                <div className="mobile-addon-card">
                    <div className="ab-cart-add-on-img">
                        <Skeleton width={'100%'} height={250} minWidth={250} />
                    </div>
                    <div className="ab-cart-add-on-title">
                        <Skeleton width={250} height={'100%'} minWidth={250} />
                    </div>
                    <div className="ab-cart-add-on-middle-right">
                        <div className="ab-cart-add-on-description">
                            <Skeleton width={150} height={10} minWidth={150} />
                        </div>
                        <div className="ab-cart-add-on-amount">
                            {' '}
                            <Skeleton
                                width={'100%'}
                                height={32}
                                minWidth={304}
                            />
                        </div>
                    </div>
                </div>
            )}

            <div className="ab-cart-add-on-bottom">
                <div className="ab-cart-add-on-price">
                    <div className="ab-cart-add-on-price-top">
                        <span className="ab-cart-add-on-price-label">
                            <Skeleton width={65} height={30} minWidth={65} />
                        </span>
                    </div>
                </div>
                <Skeleton width={96} height={30} minWidth={96} />
            </div>
            <div className="ab-cart-separate-line"></div>
        </div>
    );
};

SkeletonAddOn.propTypes = {
    isMobile: PropTypes.bool,
};

export default SkeletonAddOn;
